module.exports = __webpack_public_path__ + "media/images/homepage/OR_Logo_Black-a1b1d84c99a17eb3377552ee48e48b52.svg";